import { mapState } from 'vuex'
import TheBreadcrumbs from '@/components/common/TheBreadcrumbs/TheBreadcrumbs'
import DateTextPicker from '@/components/common/DateTextPicker/DateTextPicker'
import _ from 'lodash'
import moment from 'moment-ja'

export default {
  name: 'PageAddNews',
  layout: 'LayoutDefault',
  components: {
    TheBreadcrumbs: TheBreadcrumbs,
    DateTextPicker: DateTextPicker
  },
  data: () => ({
    breadcrumbs: [
      {
        text: 'ダッシュボード',
        disabled: false,
        href: '/'
      },
      {
        text: 'お知らせ管理',
        disabled: false,
        href: '/admin/notice'
      },
      {
        text: 'お知らせ登録',
        disabled: true,
        href: ''
      }
    ],
    notice: {
      id: null,
      display_order: 1,
      title: '',
      body: '',
      target_flag: 0
    },
    displayOrder: [1, 2, 3, 4, 5],
    displayFrom: {
      date: {
        menu: false,
        value: ''
      },
      time: {
        menu: false,
        value: ''
      }
    },
    displayTo: {
      date: {
        menu: false,
        value: ''
      },
      time: {
        menu: false,
        value: ''
      }
    },
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: {},
    menu: false,
    min: null,
    max: null,
    productAttributeDate: '',
    targetFlag: {
      disabled: false,
      item: { text: '全体', value: 0 }
    },
    targetUser: {
      disabled: true,
      item: { text: '全体ユーザー', value: 0 }
    },
    targetCompany: {
      disabled: true,
      item: { text: '全体', value: 0 }
    }

  }),
  mounted () {
    this.getContracts()
    if (this.noticeItem != null) {
      if (this.$route.params.id || !this.noticeItem.id) {
        this.notice.id = this.noticeItem.id
        this.notice.title = this.noticeItem.title
        this.notice.body = this.noticeItem.body
        let terms = _.split(this.noticeItem.display_term, '〜')
        let displayFrom = _.split(terms[0], ' ')
        displayFrom[1] = displayFrom[1].substr(0, 5)
        let displayTo = _.split(terms[1], ' ')
        displayTo[1] = displayTo[1].substr(0, 5)
        this.displayFrom.date.value = displayFrom[0]
        this.displayFrom.time.value = displayFrom[1]
        this.displayTo.date.value = displayTo[0]
        this.displayTo.time.value = displayTo[1]
        this.notice.display_order = this.noticeItem.display_order
        const targetFlag = this.noticeItem.target_flag
        this.targetFlag.item = targetFlag
        if (targetFlag === 1) {
          this.targetCompany.item = this.noticeItem.target_id
        } else if (targetFlag === 2) {
          this.targetCompany.item = this.noticeItem.user_contract_id
          this.onChangeContract(this.targetCompany.item)
          this.targetUser.item = this.noticeItem.target_id
        }
        this.processCheckDisable()
      }
    }
  },
  computed: {
    ...mapState('pageaddnews', {
      contractList: state => state.contractList,
      userList: state => state.userList,
      noticeTarget: state => state.noticeTarget,
      noticeItem: state => state.noticeItem,
      message: state => state.message
    })
  },
  watch: {
    date (val) {
      this.dateFormatted = this.formatDate(this.date)
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    getContracts () {
      this.$store.dispatch('pageaddnews/getContractList', {
        pageNo: 1,
        sortField: null,
        sortType: 'created',
        freeword: null,
        isFirst: true
      })
    },
    getUsers (contractId) {
      this.$store.dispatch('pageaddnews/getUserList', {
        contractId
      })
    },
    onChangeContract (item) {
      if (this.targetFlag.item === 2) {
        this.getUsers(item)
      }
    },
    onChangeTargetScope (item) {
      this.processCheckDisable()
    },
    onAddNews () {
      this.notice.target_flag = _.isObject(this.targetFlag.item) ? this.targetFlag.item.value : this.targetFlag.item
      if (this.targetFlag.item === 1) {
        this.notice.target_id = this.targetCompany.item
      }
      if (this.targetFlag.item === 2) {
        this.notice.target_id = this.targetUser.item
      }
      this.notice.display_from = this.displayFrom.date.value + ' ' + this.displayFrom.time.value + ':00'
      this.notice.display_to = this.displayTo.date.value + ' ' + this.displayTo.time.value + ':00'
      if (this.notice.display_from.length !== 19 || this.notice.display_to.length !== 19 ||
        moment(this.notice.display_from, 'YYYY-MM-DD HH:mm:ss').isSameOrAfter(moment(this.notice.display_to, 'YYYY-MM-DD HH:mm:ss'))) {
        this.g_addAlert('表示期間を正しく入力して下さい。', 'error', 0)
        return
      }
      if (this.notice.id) {
        this.$store.dispatch('pageaddnews/editNotice', this.notice).then(() => {
          if (this.message.type === 'error') {
            this.g_addAlert(this.message.content, this.message.type, 0)
          } else {
            this.$router.push(
              {
                name: 'PageNewsList'
              }
            )
          }
        })
      } else {
        this.$store.dispatch('pageaddnews/addNotice', this.notice).then(() => {
          if (this.message.type === 'error') {
            this.g_addAlert(this.message.content, this.message.type, 0)
          } else {
            this.$router.push(
              {
                name: 'PageNewsList'
              }
            )
          }
        })
      }
    },
    processCheckDisable () {
      if (this.targetFlag.item === 0) {
        this.targetCompany.disabled = true
        this.targetUser.disabled = true
      } else if (this.targetFlag.item === 1) {
        this.targetCompany.disabled = false
        this.targetUser.disabled = true
      } else if (this.targetFlag.item === 2) {
        this.targetCompany.disabled = false
        this.targetUser.disabled = false
      } else if (this.targetFlag.item === 3) {
        this.targetCompany.disabled = true
        this.targetUser.disabled = true
      }

      return false
    },
    onBack () {
      this.$store.dispatch('pageaddnews/clearNoticeItem')
      let backPath = '/admin/notice'
      this.$router.push(backPath)
    }
  },
  metaInfo () {
    this.$store.dispatch('meta/set', {
      title: 'お知らせ登録',
      meta: [
        {
          name: 'description',
          content: 'お知らせ登録'
        }
      ]
    })
    return this.$store.getters['meta/get']
  }
}
